import {useMutation} from '@apollo/react-hooks';
import gql from 'graphql-tag';
import {PaymentSchedule} from '../../../graphql/payment_schedule.datatypes';
import {gqlPaymentSchedule} from '../getPaymentSchedule.api';
import {updateCacheByType} from '../../../graphql/GraphQlProvider';

export interface CascadePaymentScheduleVars {
    id: number
}

interface CascadePaymentScheduleData {
    __typename?: string,
    cascadePaymentSchedule: PaymentSchedule
}

export const CASCADE_PAYMENT_SCHEDULE_MUTATION = gql`
    mutation cascadePaymentSchedule($id: Int!) {
        cascadePaymentSchedule(id: $id) {
            ${gqlPaymentSchedule}
        }
    }
`;

export const cascadePaymentSchedule = () => useMutation<CascadePaymentScheduleData, CascadePaymentScheduleVars>(
    CASCADE_PAYMENT_SCHEDULE_MUTATION,
    {
        update: updateCacheByType('PaymentSchedule'),
    }
);

export default cascadePaymentSchedule;